var React = require('react');

function LocationIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.4375 6.4375C15.4375 7.1554 15.1964 7.96974 14.8113 8.8125H16.625L19 19.5H0L2.375 8.8125H4.18866C3.80361 7.96974 3.5625 7.1554 3.5625 6.4375C3.5625 3.15831 6.22081 0.5 9.5 0.5C12.7792 0.5 15.4375 3.15831 15.4375 6.4375ZM9.5 15.9375C9.5 15.9375 7.28556 13.7231 5.56142 11.1875H4.28016L2.96071 17.125H16.0393L14.7198 11.1875H13.4386C11.7144 13.7231 9.5 15.9375 9.5 15.9375ZM11.2812 6.4375C11.2812 7.42126 10.4838 8.21875 9.5 8.21875C8.51624 8.21875 7.71875 7.42126 7.71875 6.4375C7.71875 5.45374 8.51624 4.65625 9.5 4.65625C10.4838 4.65625 11.2812 5.45374 11.2812 6.4375Z","fill":"currentColor"}));
}

LocationIcon.defaultProps = {"preserveAspectRatio":"xMinYMin meet","viewBox":"0 0 19 20","fill":"none"};

module.exports = LocationIcon;

LocationIcon.default = LocationIcon;
